import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Icon, Modal } from "antd";
import { OrderedMap, Map } from "immutable";
import { INPUT_TYPES } from "constants";
// import CompanyLosService from "./../services/company-los-services";
// import shortID from "uuid/v4";
// import { CompanyLosErpDetail } from "./../records/index";
import { ERP_DATASOURCE } from "constants/enums";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";

const getFormFields = ({
    allFieldsDisabled
}) => new OrderedMap({
    id: {
        key: "id",
        title: "Id",
        dataIndex: "id",
        label: "Id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        // onCell: record => ({
        //     record,
        //     key: "id",
        //     dataIndex: "id",
        //     title: "Id",
        //     field: {
        //         type: INPUT_TYPES.NUMBER,
        //         className: "form-field",
        //         disabled: true,
        //         trigger: "onBlur",
        //         valuePropName: "defaultValue"
        //     }
        // })
    },
    erp_data_source: {
        key: "erp_data_source",
        title: "ERP Source",
        dataIndex: "erp_data_source",
        type: INPUT_TYPES.SELECT,
        className: "form-field fb-50",
        label: "ERP Source",
        disabled: allFieldsDisabled,
        options: ERP_DATASOURCE.map((_, k) => ({
            label: k,
            value: _
        })).toList()
        // onCell: record => ({
        //     record,
        //     key: "erp_data_source",
        //     dataIndex: "erp_data_source",
        //     title: "Erp data source",
        //     field: {
        //         type: INPUT_TYPES.SELECT,
        //         className: "form-field",
        //         disabled: allFieldsDisabled,
        //         options: ERP_DATASOURCE.map((_, k) => ({
        //             label: k,
        //             value: _
        //         })).toList()
        //     }
        // })
    },
    erp_version: {
        key: "erp_version",
        title: "Erp version",
        dataIndex: "erp_version",
        type: INPUT_TYPES.TEXT,
        label: "Erp version",
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue"
        // onCell: record => ({
        //     record,
        //     key: "erp_version",
        //     dataIndex: "erp_version",
        //     title: "Erp version",
        //     field: {
        //         type: INPUT_TYPES.TEXT,
        //         className: "form-field",
        //         disabled: allFieldsDisabled,
        //         trigger: "onBlur",
        //         valuePropName: "defaultValue"
        //     }
        // })
    }
});


class CompanyErpsForm extends React.Component {
    state = {
        erpSoftwares: [],
        erpIds: new Map({}),
        removedErps: [],
        addedErps: false
    };

    // componentDidMount() {
    // CompanyLosService.getErpSoftwaresList().then(({data}) => {
    //     this.setState({
    //         erpSoftwares: data && data.results
    //     });
    // });

    // if(!this.state.erpIds.size) {
    //     this.toggleFormGrid("ADD");
    // }
    // }

    // componentDidUpdate() {
    //     if(this.props.values && this.props.values.length && !this.state.addedErps) {
    //         const values = new List(this.props.values)
    //             .toMap()
    //             .mapEntries(([, v]) => [v.id, v]);
    //         this.setState({
    //             erpIds: values.map((_, k) => {
    //                 return {
    //                     ..._,
    //                     erp_version: _.erp_version !== "" ? _.erp_version : null,
    //                     key: k,
    //                     index: k
    //                 };
    //             }),
    //             addedErps: true
    //         });
    //     }
    // }

    // toggleFormGrid = (action = "ADD", id) => {
    //     const { erpIds } = this.state;
    //     let removedErps = this.state.removedErps;
    //     const newID = shortID();
    //     switch (action) {
    //     case "ADD":
    //         this.setState({
    //             erpIds: erpIds.set(newID, {...new CompanyLosErpDetail().toJS(), key: newID, index: newID})
    //         });
    //         break;
    //     case "REMOVE": {
    //         removedErps.push(id);
    //         this.setState({
    //             removedErps: removedErps
    //         });
    //         break;
    //     }
    //     default:
    //     }
    // };

    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    this.props.onValuesSubmit(values);
                }
            });
        }
    }
    // tableFormCell = () => props => {
    //     const { dataIndex, record, field, ...restProps } = props;
    //     const index = record.index;
    //     return (
    //         <td {...restProps}>
    //             {this.fieldGenerator(
    //                 `[${index}].${dataIndex}`,
    //                 { ...field, defaultValue: record[dataIndex] },
    //                 this.getValidateStatus(dataIndex)
    //             )()}
    //         </td>);
    // }
    // tableCell = this.tableFormCell(this.props.form);
    render() {
        // const body = {
        //     body: { cell: this.tableCell, row: props => <tr {...props} /> }
        // };
        return (
            <Modal 
                width={800}
                bodyStyle={{
                    paddingRight: "3rem",
                    paddingLeft: "3rem"
                }}
                footer={null}
                title="Add/Update ERP System"
                visible={this.props.visible}
                onCancel={this.props.toggleErpModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    <div className={"form-row align-items-center"}>
                        {this.formFields.map((field, fieldName) => {
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        // <Modal onCancel={this.props.toggleErpModal} visible={this.props.visible}>
        //     <Form onSubmit={this.onValuesSubmit}>
        //         <div className={"form-row align-items-center mb-10"}>
        //             <Table
        //                 style={{
        //                     width: "100%"
        //                 }}
        //                 components={
        //                     body
        //                 }
        //                 className={"table-padding"}
        //                 dataSource={
        //                     this.state.erpIds.toList().toArray()
        //                 }
        //                 key={"id"}
        //                 columns={this.formFields.toList().toArray()}
        //                 footer={null}
        //                 pagination={false}
        //             />
        //         </div>
        //         <div className={"form-row flex-row-reverse p-10"}>
        //             <Button type={"primary"} htmlType={"submit"}>
        //                 {this.props.loading ? <Icon type={"loading"} /> : null}
        //                 Update
        //             </Button>
        //             <Button className={"mr-5"} onClick={this.toggleFormGrid.bind(null, "ADD")}>
        //                 <Icon type={"plus"} />
        //                 Add New
        //             </Button>
        //         </div>
        //     </Form>
        // </Modal>
        );
    }
}

CompanyErpsForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.bool,
    toggleErpModal: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value) => {
                            let message = null;
                            if (value === null) {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanyErpsForm);